import {
  AccountBg1,
  AccountBg2,
  bannerAud,
  bannerCad,
  bannerChf,
  bannerCny,
  bannerEur,
  bannerGbp,
  bannerHkd,
  bannerJpy,
  bannerNzd,
  bannerUsd,
} from '@/shared/assets';

export const ACC_IMAGES = {
  all: AccountBg2,
  USD: bannerUsd,
  GBP: bannerGbp,
  EUR: bannerEur,
  HKD: bannerHkd,
  NZD: bannerNzd,
  CNY: bannerCny,
  JPY: bannerJpy,
  CAD: bannerCad,
  AUD: bannerAud,
  CHF: bannerChf,
};

export const DEFAULT_IMAGE = AccountBg1;

export const FIELD_NAMES = {
  //TODO: actual VabsPaymentSystem
  SWIFT: {
    accountNumber: 'Account number (IBAN)',
    bankCode: 'Bank BIC/SWIFT',
  },
  ACH: {
    accountNumber: 'Account number',
    bankCode: 'Routing number (ACH/Wire)',
  },
  WIRE: {
    accountNumber: 'Account number',
    bankCode: 'Routing number (ACH/Wire)',
  },
  BSB: {
    accountNumber: 'Account number',
    bankCode: 'BSB number',
  },
  IFSC: {
    accountNumber: 'Account number',
    bankCode: 'Bank code',
  },
  INNER: {
    accountNumber: 'Account number',
    bankCode: 'Bank code',
  },
};
